/* TrueVitaminBoost custom scripts. Loaded from layout/theme.liquid (defer). */

/* Product gallery: up/down (desktop) and left/right (mobile) arrows for the thumbnail strip.
   Uses the Swiper instances created by wpbingo.js (el.swiper).
   Arrows ONLY scroll the thumbnail strip by THUMBS_STEP thumbnails; the main image does not change.
   The shopper then clicks the thumbnail they want. */
(function () {
  var THUMBS_STEP = 3;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(ctx) {
    var thumbsEl = ctx.querySelector('.js-product-thumbnails');
    var mediaEl = ctx.querySelector('.js-product-media-group');
    if (!thumbsEl || !mediaEl) return true;           // nothing to do
    if (thumbsEl.getAttribute('data-tvb-nav')) return true;
    var ts = thumbsEl.swiper, ms = mediaEl.swiper;
    if (!ts || !ms) return false;                       // swiper not ready yet
    thumbsEl.setAttribute('data-tvb-nav', '1');

    var holder = thumbsEl.closest('.product-single__main-thumbnail') || thumbsEl.parentElement;
    holder.classList.add('tvb-thumbs-nav');

    function button(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tvb-thumbs-arrow tvb-thumbs-arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = ICON;
      holder.appendChild(b);
      return b;
    }
    var prev = button('prev', 'Show previous thumbnails');
    var next = button('next', 'Show more thumbnails');

    function clamp(t) { return Math.max(ts.maxTranslate(), Math.min(ts.minTranslate(), t)); }

    // Index of the first thumbnail whose start is inside the visible window.
    function firstVisible() {
      var from = -ts.translate;
      for (var i = 0; i < ts.slidesGrid.length; i++) {
        if (ts.slidesGrid[i] >= from - 0.5) return i;
      }
      return ts.slidesGrid.length - 1;
    }

    // Scroll the strip by `dir * THUMBS_STEP` thumbnails, snapping to a thumbnail edge.
    function scrollThumbs(dir) {
      var n = ts.slidesGrid.length;
      if (!n) return;
      var i = Math.max(0, Math.min(n - 1, firstVisible() + dir * THUMBS_STEP));
      ts.translateTo(clamp(-ts.slidesGrid[i]), 300, false, false);
    }
    prev.addEventListener('click', function () { scrollThumbs(-1); });
    next.addEventListener('click', function () { scrollThumbs(1); });

    function updateButtons() {
      prev.disabled = ts.translate >= ts.minTranslate() - 0.5;
      next.disabled = ts.translate <= ts.maxTranslate() + 0.5;
    }

    // When the main image changes by other means (its own arrows, swipe, thumbnail click),
    // make sure the active thumbnail is visible, moving the strip as little as possible.
    function revealActive() {
      var i = ms.params.loop ? ms.realIndex : ms.activeIndex;
      var pos = ts.slidesGrid[i], len = ts.slidesSizesGrid[i];
      if (pos == null || len == null) return;
      var from = -ts.translate, to = from + ts.size, target = null;
      if (pos < from - 0.5) target = -pos;
      else if (pos + len > to + 0.5) target = -(pos + len - ts.size);
      if (target !== null) ts.translateTo(clamp(target), 300, false, false);
    }

    // Swiper's thumbs module (and wpbingo's thumb-click handler) call thumbsSwiper.slideTo(),
    // which jumps the strip so the active thumb lands first. Swallow those calls.
    ts.tvbNativeSlideTo = ts.slideTo;
    ts.slideTo = function () { return false; };

    ms.on('slideChange', revealActive);
    ts.on('setTranslate', updateButtons);
    ts.on('transitionEnd', updateButtons);
    ts.on('resize', updateButtons);
    ts.update();
    updateButtons();
    return true;
  }

  function init() {
    var tries = 0;
    (function attempt() {
      var pending = false;
      document.querySelectorAll('.js-product-thumbnails').forEach(function (t) {
        var ctx = t.closest('.row') || t.closest('.product-single__media');
        if (ctx && !setup(ctx)) pending = true;
      });
      if (pending && ++tries < 40) setTimeout(attempt, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();

/* ===== Product page: estimated delivery (blocks/single-estimated-delivery.liquid) =====
   Same rule as the Shipping Policy: processing 1–2 business days + transit 3–5 business days
   => delivery window = order date + 4 … 7 business days (weekends and US federal holidays skipped).
   "Today" is taken in US Eastern time. No countdown. Holidays: update the list each year. */
(function () {
  var HOLIDAYS = [
    '2026-01-01', '2026-01-19', '2026-02-16', '2026-05-25', '2026-06-19', '2026-07-03', '2026-09-07',
    '2026-10-12', '2026-11-11', '2026-11-26', '2026-12-25',
    '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18', '2027-07-05', '2027-09-06',
    '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'
  ];
  var MIN_DAYS = 4, MAX_DAYS = 7;
  function ymd(d) {
    return d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2);
  }
  function isBusinessDay(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(ymd(d)) === -1;
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBusinessDay(d)) n--; }
    return d;
  }
  function todayEastern() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    } catch (e) {
      var n = new Date(); return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
    }
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
  }
  function run() {
    var els = document.querySelectorAll('[data-tvb-delivery]');
    if (!els.length) return;
    var t = todayEastern();
    var from = addBusinessDays(t, MIN_DAYS), to = addBusinessDays(t, MAX_DAYS);
    els.forEach(function (el) {
      el.innerHTML = 'Free standard shipping. Order today and get it between <strong>' + fmt(from) +
        '</strong> and <strong>' + fmt(to) + '</strong>.';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ===== Shopify cookie banner (Settings > Customer privacy): button order =====
   Shopify renders: Manage preferences | Accept | Decline. We show:
   Manage preferences | Decline | Accept. The button element itself is moved (not CSS order),
   so keyboard Tab order matches what is on screen. Shopify's click handlers stay attached.
   Both buttons keep Shopify's identical styling (equal choice). */
(function () {
  function reorder() {
    var accept = document.getElementById('shopify-pc__banner__btn-accept');
    var decline = document.getElementById('shopify-pc__banner__btn-decline');
    if (!accept || !decline || accept.parentNode !== decline.parentNode) return false;
    if (decline.nextElementSibling !== accept) decline.parentNode.insertBefore(accept, decline.nextSibling);
    return true;
  }
  function watch() {
    reorder();
    // the banner can be added late or re-rendered; keep watching for a while
    var mo = new MutationObserver(function () { reorder(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();

/* ===== Footer "Cookie Preferences" link (sections/footer-group.json, list_item_CkPref) =====
   Opens Shopify's cookie preferences window, so a visitor can change or withdraw an earlier
   choice at any time. The link's own address is /policies/privacy-policy#cookie-preferences:
   if Shopify's banner script is not available, the click simply opens the Privacy Policy. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#cookie-preferences"]');
    if (!a) return;
    var pb = window.privacyBanner;
    if (!pb || typeof pb.showPreferences !== 'function') return;
    e.preventDefault();
    try { pb.showPreferences(); } catch (err) { window.location.href = a.href; }
  });
})();

/* ===== Footer "Partner Program" link (sections/footer-group.json, list_item_Partnr) =====
   The link points to the production partner site; on unpublished themes (DEV) it is switched to the test site. */
(function () {
  var S = window.Shopify || {};
  if (S.theme && S.theme.role === 'main') return;
  function fix() {
    var as = document.querySelectorAll('a[href*="//tvb-partners.truevitaminboost.workers.dev"]');
    for (var i = 0; i < as.length; i++) as[i].href = as[i].href.replace('//tvb-partners.', '//tvb-partners-dev.');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();

/* ---------- TVB analytics (partners/, stage 1) ----------
   Sends page data straight to our server (Cloudflare), respecting the cookie banner:
   - "full": visitor accepted analytics, or made no choice yet in the US (opt-out law) or where Shopify allows it
            -> page views, scroll, active time, gallery photos, videos, page sections, add to cart
   - "anon": visitor declined (or no choice outside the US) -> one anonymous page-view count, no id, no storage
   Referral links (?ref=&l=) are always written into the cart attributes so a purchase can be credited;
   in "full" mode the last referral click is also kept in the browser (up to 90 days) and put back into the cart
   once per session, so a later order is still credited (the server checks the attribution period itself).
   Checkout and purchase are reported by the Shopify custom pixel "TVB tracking" (theme code can't run there). */
(function () {
  if (window.__tvbTrack) return;
  window.__tvbTrack = true;
  var S = window.Shopify || {};
  var role = S.theme && S.theme.role;
  // published (LIVE) theme -> production server; DEV and other unpublished themes -> test server
  var ENDPOINT = role === 'main' ? 'https://tvb-partners.truevitaminboost.workers.dev/c'
                                 : 'https://tvb-partners-dev.truevitaminboost.workers.dev/c';
  if (!ENDPOINT || !window.fetch) return;

  var params = new URLSearchParams(location.search);
  var debugMode = role !== 'main' ? params.get('tvb_debug') : null; // test switch on unpublished themes only
  var pvk = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
  var path = location.pathname;
  var t0 = Date.now(); // page start: "first seen" times are ms after this
  var mode = null, vid = null, pvSent = false, anonSent = false;
  var maxScroll = 0, active = 0, lastAct = Date.now(), lastSent = '', dirty = false;
  // idle = tab on screen but no mouse/keys/scroll/touch for IDLE ms (and no video playing): not counted as viewing
  var IDLE = 30000, idleMs = 0, idleFrom = null, idleNow = false, idleN = 0;
  var hidMs = 0, hidFrom = null, hidSince = null; // tab in background / other app
  var imgs = {}, vids = {}, secs = {};
  var store = { get: function (s, k) { try { return window[s].getItem(k); } catch (e) { return null; } },
                set: function (s, k, v) { try { window[s].setItem(k, v); } catch (e) {} },
                del: function (s, k) { try { window[s].removeItem(k); } catch (e) {} } };

  function send(obj) {
    var body = JSON.stringify(obj);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
  }
  function base(t, eid) {
    return { t: t, cid: vid, eid: eid, ts: Date.now(), url: location.href, ref: document.referrer || '', title: document.title || '' };
  }

  // ---- consent
  function decide() {
    if (debugMode === 'full' || debugMode === 'anon') return debugMode;
    var cp = S.customerPrivacy;
    if (!cp) return 'anon';
    var c = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    if (c.analytics === 'yes') return 'full';
    if (c.analytics === 'no') return 'anon';
    if (cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) return 'full';
    var region = (cp.getRegion && cp.getRegion()) || '';
    return /^US/.test(region) ? 'full' : 'anon';
  }
  function applyMode() {
    var m = decide();
    if (m === mode) return;
    mode = m;
    if (mode === 'full') {
      vid = store.get('localStorage', 'tvb_vid');
      if (!vid) { vid = 'v-' + pvk; store.set('localStorage', 'tvb_vid', vid); }
      if (!pvSent) {
        pvSent = true;
        var pv = base('page_viewed', pvk);
        pv.d = { scr: screen.width + 'x' + screen.height + '@' + (Math.round((window.devicePixelRatio || 1) * 100) / 100), vp: window.innerWidth + 'x' + window.innerHeight,
                 lang: (navigator.language || '').slice(0, 20) };
        send(pv);
      }
      cartVid();
      keepRef();
    } else {
      vid = null;
      // was tracked before (e.g. accepted, then declined): drop the visitor id from the cart too
      if (store.get('localStorage', 'tvb_vid')) cartUpdate({ _tvb_vid: '' });
      store.del('localStorage', 'tvb_vid');
      store.del('localStorage', 'tvb_ref'); // declined: no referral memory in the browser (the current cart keeps the tag)
      store.del('sessionStorage', 'tvb_cart_vid');
      if (!anonSent && !pvSent) { anonSent = true; send({ t: 'anon_pv', ts: Date.now(), url: location.href, ref: document.referrer || '' }); }
    }
  }

  // ---- cart attributes: referral (always) and visitor id (full mode, once per session)
  function cartUpdate(attrs) {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }
  var refRec = null; // referral click on this page
  function cartRef() {
    var ref = (params.get('ref') || '').toLowerCase().replace(/[^a-z0-9._\-]/g, '').slice(0, 40);
    if (!ref) return;
    var link = (params.get('l') || '').toLowerCase().replace(/[^a-z0-9._\-]/g, '').slice(0, 60);
    refRec = { r: ref, l: link, t: new Date().toISOString() };
    store.set('sessionStorage', 'tvb_ref_synced', '1');
    cartUpdate({ _tvb_ref: ref, _tvb_link: link, _tvb_ref_at: refRec.t });
  }
  // full mode only: remember the last referral click (90 days max) and restore it into the cart once per session
  function keepRef() {
    if (refRec) { store.set('localStorage', 'tvb_ref', JSON.stringify(refRec)); return; }
    if (store.get('sessionStorage', 'tvb_ref_synced')) return;
    var rec = null;
    try { rec = JSON.parse(store.get('localStorage', 'tvb_ref') || 'null'); } catch (e) {}
    if (!rec || !rec.r || !(Date.now() - Date.parse(rec.t) < 90 * 864e5)) { store.del('localStorage', 'tvb_ref'); return; }
    store.set('sessionStorage', 'tvb_ref_synced', '1');
    cartUpdate({ _tvb_ref: rec.r, _tvb_link: rec.l || '', _tvb_ref_at: rec.t });
  }
  function cartVid() {
    if (!vid || store.get('sessionStorage', 'tvb_cart_vid') === vid) return;
    store.set('sessionStorage', 'tvb_cart_vid', vid);
    cartUpdate({ _tvb_vid: vid });
  }

  // ---- helpers
  function fileKey(src) {
    if (!src) return '';
    try { src = new URL(src, location.href).pathname; } catch (e) { src = String(src).split('?')[0]; }
    var f = src.split('/').pop() || '';
    return f.replace(/_(\d+x\d*|x\d+|\d+x)(?=\.)/i, '').slice(0, 180);
  }
  function scrollPct() {
    var h = document.documentElement, max = Math.max(h.scrollHeight, document.body.scrollHeight) - window.innerHeight;
    if (max <= 0) return 100;
    return Math.min(100, Math.round((window.scrollY || h.scrollTop) / max * 100));
  }
  function onScroll() { var s = scrollPct(); if (s > maxScroll) { maxScroll = s; dirty = true; } lastAct = Date.now(); }
  ['mousemove', 'keydown', 'touchstart', 'click', 'wheel'].forEach(function (ev) {
    window.addEventListener(ev, function () {
      lastAct = Date.now();
      if (idleNow) { idleNow = false; dirty = true; } // came back
    }, { passive: true });
  });
  window.addEventListener('scroll', onScroll, { passive: true });

  // ---- gallery photos
  var visibleSlides = new Set();
  function slideInfo(el) {
    var img = el.querySelector('img'), video = el.querySelector('video');
    var key = video ? fileKey((video.querySelector('source') || {}).src || video.currentSrc) : fileKey(img && (img.currentSrc || img.src || img.getAttribute('data-src')));
    var label = el.getAttribute('data-slick-media-label') || (img && img.alt) || '';
    return { key: key, label: label.slice(0, 180), isVideo: !!video };
  }
  function img(key, label) {
    if (!imgs[key]) imgs[key] = { k: key, l: label, s: 0, c: 0, f: null };
    return imgs[key];
  }
  function bindGallery() {
    var slides = document.querySelectorAll('.product-single__main-media .js-product-media-item');
    if (!slides.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.intersectionRatio >= 0.6) visibleSlides.add(en.target); else visibleSlides.delete(en.target); });
    }, { threshold: [0, 0.6, 1] });
    slides.forEach(function (s) { if (!slideInfo(s).isVideo) io.observe(s); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.product-single__main-thumbnail .swiper-slide');
      if (!t) return;
      var i = t.querySelector('img');
      var key = fileKey(i && (i.currentSrc || i.src || i.getAttribute('data-src')));
      if (key) { var r = img(key, (i && i.alt) || ''); r.c++; if (r.f == null) r.f = Date.now() - t0; dirty = true; }
    }, true);
  }

  // ---- page sections (every Shopify section automatically + optional [data-tvb-block="name"])
  var visibleSecs = new Set();
  function bindSections() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[id^="shopify-section-"], [data-tvb-block], .shopify-policy__container');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var big = en.intersectionRect.height >= window.innerHeight * 0.5;
        if (en.intersectionRatio >= 0.5 || big) visibleSecs.add(en.target); else visibleSecs.delete(en.target);
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    var n = 0;
    els.forEach(function (el) {
      if (el.offsetHeight < 40) return;
      if (/header|announcement/i.test(el.id)) return; // always on screen: not informative
      var key, label;
      if (el.classList.contains('shopify-policy__container')) {
        key = 'policy-text'; label = 'policy';
      } else if (el.hasAttribute('data-tvb-block')) {
        key = 'block:' + el.getAttribute('data-tvb-block');
        label = el.getAttribute('data-tvb-block');
      } else {
        key = el.id.replace('shopify-section-', '').replace(/^.*__/, '');
        var h = el.querySelector('h1, h2, h3');
        label = (h && h.textContent.replace(/\s+/g, ' ').trim()) || key;
      }
      key = key.slice(0, 120);
      el.__tvbSec = key;
      if (!secs[key]) secs[key] = { k: key, l: label.slice(0, 100), o: n++, s: 0, f: null };
      io.observe(el);
    });
  }

  // ---- videos
  function bindVideos() {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.__tvb) return; v.__tvb = true;
      function rec() {
        var key = fileKey((v.querySelector('source') || {}).src || v.currentSrc);
        if (!key) return null;
        if (!vids[key]) {
          var holder = v.closest('[data-slick-media-label]');
          vids[key] = { k: key, l: ((holder && holder.getAttribute('data-slick-media-label')) || '').slice(0, 180), p: 0, m: 0, s: 0, f: null };
        }
        return vids[key];
      }
      v.addEventListener('play', function () { var r = rec(); if (r) { r.p++; if (r.f == null) r.f = Date.now() - t0; dirty = true; } });
      v.addEventListener('timeupdate', function () {
        var r = rec(); if (!r || !v.duration) return;
        var pct = Math.min(100, Math.round(v.currentTime / v.duration * 100));
        var watched = 0; for (var i = 0; i < v.played.length; i++) watched += v.played.end(i) - v.played.start(i);
        if (pct > r.m) r.m = pct;
        r.s = Math.round(watched * 10) / 10; dirty = true;
      });
    });
  }

  // ---- add to cart (theme uses AJAX /cart/add)
  function cartAdded() {
    if (mode !== 'full') return;
    var o = base('add_to_cart', pvk + '-atc-' + Date.now());
    o.d = { title: (document.title || '').slice(0, 200) };
    send(o);
  }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  var of = window.fetch;
  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url);
    var p = of.apply(this, arguments);
    if (isAdd(u)) p.then(function (r) { if (r && r.ok) cartAdded(); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isAdd(u)) this.addEventListener('load', function () { if (this.status < 400) cartAdded(); });
    return xo.apply(this, arguments);
  };

  // ---- 1-second ticker
  function videoPlaying() {
    var v = document.querySelectorAll('video');
    for (var i = 0; i < v.length; i++) if (!v[i].paused && !v[i].ended) return true;
    return false;
  }
  setInterval(function () {
    if (mode !== 'full' || document.visibilityState !== 'visible') return;
    var now = Date.now();
    if (now - lastAct >= IDLE && !videoPlaying()) {
      // nobody is looking: count it separately, do not add to page / block / photo time
      if (!idleNow) { idleNow = true; idleN++; if (idleFrom == null) idleFrom = lastAct - t0; dirty = true; }
      idleMs += 1000;
      return;
    }
    if (videoPlaying()) lastAct = Math.max(lastAct, now - IDLE + 1000);
    active += 1000; dirty = true;
    var since = now - t0;
    visibleSlides.forEach(function (el) {
      var inf = slideInfo(el); if (!inf.key) return;
      var r = img(inf.key, inf.label); r.s += 1; if (r.f == null) r.f = since; dirty = true;
    });
    visibleSecs.forEach(function (el) { var r = secs[el.__tvbSec]; if (r) { r.s += 1; if (r.f == null) r.f = since; dirty = true; } });
  }, 1000);

  function publish(force) {
    if (mode !== 'full' || (!dirty && !force)) return;
    var vals = function (o) { return Object.keys(o).map(function (k) { return o[k]; }); };
    var hid = hidMs + (hidSince != null ? Date.now() - hidSince : 0);
    var data = { pvk: pvk, path: path, scroll: maxScroll, active: active, img: vals(imgs), vid: vals(vids),
                 sec: vals(secs).filter(function (r) { return r.s > 0; }),
                 idle: idleMs, idleFrom: idleFrom, idleN: idleN, hid: hid, hidFrom: hidFrom };
    var s = JSON.stringify(data);
    if (s === lastSent) return;
    lastSent = s; dirty = false;
    var o = base('tvb_page', pvk + '-s'); o.d = data;
    send(o);
  }

  function start() {
    onScroll();
    bindGallery();
    bindSections();
    bindVideos();
    setTimeout(bindVideos, 3000);
    cartRef();
    setTimeout(function () { publish(true); }, 10000);
    setInterval(function () { publish(false); }, 30000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        hidSince = Date.now(); if (hidFrom == null) hidFrom = hidSince - t0; dirty = true;
        publish(false);
      } else if (hidSince != null) {
        hidMs += Date.now() - hidSince; hidSince = null; lastAct = Date.now(); idleNow = false; dirty = true;
      }
    });
    window.addEventListener('pagehide', function () { publish(false); });
    // leaving by a link: send the summary right away (short visits would otherwise be lost)
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && a.href && a.target !== '_blank') publish(false);
    }, true);
    document.addEventListener('visitorConsentCollected', function () { applyMode(); });
    if (S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { applyMode(); });
      setTimeout(function () { if (!mode) applyMode(); }, 5000);
    } else {
      applyMode();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ===== Product cards: photo slider + product list arrows =====
   1) Card photo sliders were initialised while the extra photos were hidden by theme CSS
      (see tvb-custom.css) -> Swiper measured 1 slide and locked the arrows. Re-measure them.
   2) Product list arrows (home MAX-FILL): centre vertically on the cards (photo + text). */
(function () {
  function updateCardSliders() {
    document.querySelectorAll('.product-card__image-wrapper.slider .product-card__image').forEach(function (el) {
      var sw = el.swiper;
      if (sw && !sw.destroyed && sw.slides && sw.slides.length > 1) {
        try { sw.update(); } catch (e) {}
      }
    });
  }
  function centerListArrows() {
    document.querySelectorAll('.wpbingo-widget--products .content-swiper-nav > .bwp-swiper-slider').forEach(function (s) {
      // average centre (photo top .. text bottom) of the cards currently in view
      var sr = s.getBoundingClientRect(), sum = 0, n = 0;
      s.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide .product-card').forEach(function (c) {
        var b = c.getBoundingClientRect();
        if (b.height > 0 && b.right > sr.left + 1 && b.left < sr.right - 1) { sum += (b.top + b.bottom) / 2 - sr.top; n++; }
      });
      if (n > 0) s.style.setProperty('--tvb-arrows-y', Math.round(sum / n) + 'px');
    });
  }
  function run() { updateCardSliders(); centerListArrows(); }
  function start() {
    run();
    setTimeout(run, 600);
    setTimeout(run, 2000);
    window.addEventListener('load', run);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* "Before you leave" offer popup (#before-you-leave, snippets/before-you-leave.liquid, CODE25OFF).
   Rules (owner's decision 17.10.2026):
   - only for a FIRST-TIME visitor: the browsing session in which the site was opened for the first time
     (localStorage tvb_first_seen + sessionStorage tvb_first_session);
   - opens after the visitor has been idle on the page for N minutes (theme setting "Time",
     settings.time_you_leave, data-time; decimals allowed): no mouse / keys / scroll / touch,
     tab visible, no video playing;
   - shown ONCE per browser (localStorage tvb_offer_shown), never again, even if not closed.
   The theme's own trigger (left the tab / window blur) is removed in wpbingo.js.
   Test: add ?tvb_offer_test=1 to any URL -> resets the flags and uses 5 s idle. */
(function () {
  var box = document.getElementById('before-you-leave');
  if (!box) return;
  var KEY_SEEN = 'tvb_first_seen', KEY_SESSION = 'tvb_first_session', KEY_SHOWN = 'tvb_offer_shown';
  var test = /[?&]tvb_offer_test=1\b/.test(location.search);
  var ls, ss;
  try { ls = window.localStorage; ss = window.sessionStorage; ls.getItem(KEY_SEEN); } catch (e) { return; } // no storage -> never show
  try {
    if (test) { ls.removeItem(KEY_SEEN); ls.removeItem(KEY_SHOWN); ss.removeItem(KEY_SESSION); }
    if (!ls.getItem(KEY_SEEN)) { ls.setItem(KEY_SEEN, String(Date.now())); ss.setItem(KEY_SESSION, '1'); }
    if (ss.getItem(KEY_SESSION) !== '1' || ls.getItem(KEY_SHOWN)) return; // not a first visit, or already shown
  } catch (e) { return; }

  var minutes = parseFloat(box.getAttribute('data-time'));
  if (!(minutes > 0)) minutes = 1;
  var IDLE = test ? 5000 : Math.round(minutes * 60000);
  var lastAct = Date.now(), done = false;

  function videoPlaying() {
    var v = document.getElementsByTagName('video');
    for (var i = 0; i < v.length; i++) { if (!v[i].paused && !v[i].ended && v[i].readyState > 2) return true; }
    return false;
  }
  function act() { lastAct = Date.now(); }
  ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'touchmove', 'click'].forEach(function (ev) {
    window.addEventListener(ev, act, { passive: true, capture: true });
  });
  window.addEventListener('scroll', act, { passive: true, capture: true });
  document.addEventListener('visibilitychange', act); // time with the tab hidden is not "idle on the page"

  function show() {
    box.classList.remove('hiden');
    box.classList.add('active');
    // the theme CSS shows the popup only from 768px (#before-you-leave.active { display:flex } in @media min-width:768px);
    // on a narrow screen it stays invisible -> do not count it as shown, wait for the next idle period
    if (getComputedStyle(box).display === 'none') { box.classList.remove('active'); box.classList.add('hiden'); act(); return; }
    done = true; clearInterval(timer);
    try { ls.setItem(KEY_SHOWN, String(Date.now())); } catch (e) {}
  }
  var timer = setInterval(function () {
    if (done) return;
    if (document.hidden || videoPlaying()) { act(); return; }
    if (box.classList.contains('active')) { done = true; clearInterval(timer); return; }
    if (Date.now() - lastAct >= IDLE) show();
  }, 1000);
})();
/* Offer popup: click on the code (button[data-tvb-apply-code]) -> the discount code is added to the cart
   (POST /cart/update.js {discount}; fallback GET /discount/<code>), copied to the clipboard, and a message is shown.
   Shopify checks "one use per customer" at checkout. */
(function () {
  function msgFor(btn) {
    var box = btn.closest('.code') || btn.parentNode;
    var m = box.querySelector('.tvb-offer-code-msg');
    if (!m) { m = document.createElement('p'); m.className = 'tvb-offer-code-msg'; m.setAttribute('role', 'status'); m.setAttribute('aria-live', 'polite'); btn.insertAdjacentElement('afterend', m); }
    return m;
  }
  function say(btn, ok, text) {
    var m = msgFor(btn);
    m.className = 'tvb-offer-code-msg ' + (ok ? 'is-ok' : 'is-err');
    m.textContent = text;
  }
  function viaCart(code) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        var list = (cart && cart.discount_codes) || [];
        for (var i = 0; i < list.length; i++) { if (String(list[i].code).toUpperCase() === code.toUpperCase()) return { cart: cart, applicable: !!list[i].applicable }; }
        throw new Error('code not in cart');
      });
  }
  function viaLink(code) {
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('link ' + r.status); return { cart: null, applicable: false }; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tvb-apply-code]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    var code = btn.getAttribute('data-tvb-apply-code');
    try { if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {}); } catch (x) {}
    btn.classList.add('is-busy');
    viaCart(code).catch(function () { return viaLink(code); }).then(function (res) {
      btn.classList.add('is-applied');
      btn.textContent = '\u2713 ' + code;
      var hasItems = res.cart && res.cart.item_count > 0;
      say(btn, true, (res.applicable && hasItems)
        ? 'Code ' + code + ' added to your cart \u2014 25% off is applied.'
        : 'Code ' + code + ' added to your cart \u2014 25% off will be applied at checkout.');
      document.dispatchEvent(new CustomEvent('tvb:discount-applied', { detail: { code: code } }));
    }).catch(function () {
      say(btn, false, 'Could not add the code automatically. Please enter ' + code + ' at checkout (it is copied).');
    }).then(function () { btn.classList.remove('is-busy'); });
  });
})();
/* Add-to-cart error message (18.10.2026). The theme silently swallowed Shopify's refusal
   (wpbingo.js itemErrorCallback: toast commented out) - the button just stopped spinning.
   Now any failed POST /cart/add.js (jQuery) shows a short message next to the button that was used. */
(function () {
  var lastBtn = null;
  function remember(e) {
    var t = e.target;
    var btn = t.closest && t.closest('.btn--add-to-cart, .js-btn-addtocart, [name="add"]');
    if (!btn && t.matches && t.matches('form[data-product-form], form[action*="/cart/add"]')) btn = t.querySelector('.btn--add-to-cart, [type="submit"]');
    if (btn) lastBtn = btn;
  }
  document.addEventListener('click', remember, true);
  document.addEventListener('submit', remember, true);

  function textFor(status, data) {
    var d = String((data && (data.description || data.message)) || '');
    var m = d.match(/only add (\d+)/i) || d.match(/all (\d+) .* (?:are|is) in your cart/i) || d.match(/only (\d+) .* left/i);
    if (m) return 'Sorry, only ' + m[1] + ' of this item can be added to your cart.';
    if (/can.?t add more|cannot add more|not enough|exceeds/i.test(d)) return 'Sorry, there is not enough stock to add more of this item.';
    if (/sold out|not available|unavailable/i.test(d)) return 'Sorry, this item is currently unavailable.';
    if (status === 0) return 'No connection. Please check your internet and try again.';
    return 'Sorry, this item could not be added to your cart. Please try again.';
  }
  function show(btn, text) {
    var host = btn.closest('.product-single__add-to-cart') || btn.closest('form') || btn.parentNode;
    var box = host.parentNode.querySelector(':scope > .tvb-atc-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'tvb-atc-error';
      box.setAttribute('role', 'alert');
      host.insertAdjacentElement('afterend', box);
    }
    box.textContent = text;
    box.hidden = false;
    clearTimeout(box._t);
    box._t = setTimeout(function () { box.hidden = true; }, 8000);
  }
  function hook() {
    if (!window.jQuery) return false;
    jQuery(document).ajaxError(function (ev, xhr, settings) {
      if (!settings || !/\/cart\/add(\.js)?(\?|$)/.test(settings.url || '')) return;
      var data = null;
      try { data = JSON.parse(xhr.responseText); } catch (x) {}
      var btn = lastBtn && document.contains(lastBtn) ? lastBtn : document.querySelector('.product-single__add-to-cart .btn--add-to-cart');
      if (btn) show(btn, textFor(xhr.status, data));
    });
    // a new successful add hides old messages
    jQuery(document).ajaxSuccess(function (ev, xhr, settings) {
      if (settings && /\/cart\/add(\.js)?(\?|$)/.test(settings.url || '')) {
        document.querySelectorAll('.tvb-atc-error').forEach(function (b) { b.hidden = true; });
      }
    });
    return true;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();